import { getCategoryDescriptions, getLabelValues, localizeLabelValueCategory, mapLabelValueToListItem, RestLabelValueResponse, sortLabelValues } from '@tableau/catalog-ui-temp';
import { restApiService } from '@tableau/vizportalclient-common-components';

import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { IListFetcher } from '~src/httpClient/fetchers/IListFetcher';
import { ListResult } from '~src/httpClient/fetchers/ListResult';
import { IPagedItemsParams } from '~src/httpClient/serverApi/types/IPage';

import { ILabelValueInfo } from '../models/ILabelValueInfo';

export class LabelValueResourceFetcher implements IListFetcher<ILabelValueInfo> {
    public fetchList(_params: IPagedItemsParams): Promise<ListResult<ILabelValueInfo>> {
        return getLabelValueLandingPageCall()
        .then((result) => {
            const startIndex = _params.page ? _params.page.startIndex : 0;
            return new ListResult<ILabelValueInfo>(mapLabelValueResultToLabelValueGrid(result), startIndex, result.values.length);
        });
    }
}

type LabelValueLandingPageCall = {
  readonly values: ReadonlyArray<RestLabelValueResponse>;
  readonly categories: Record<string, string>;
}

export async function getLabelValueLandingPageCall(): Promise<LabelValueLandingPageCall>{
    const siteLuid = SessionSiteSelectors.siteLuid(getAppStore().getState());
    const {makeJsonRestApiRequest} = restApiService({siteLuid});
    const [categories, values] = await Promise.all([
      getCategoryDescriptions({ makeJsonRestApiRequest }),
      getLabelValues({ makeJsonRestApiRequest }),
    ]);

    return { categories, values };
}

export function mapLabelValueResultToLabelValueGrid({ values, categories }: LabelValueLandingPageCall): ILabelValueInfo[]{
  return values.map((result, i) => ({
    contentType: 'labelValue',
    id: i.toString(),
    category: result.category,
    localizedCategory:localizeLabelValueCategory(result.category, result.name),
    value: result.name,
    localizedValue: mapLabelValueToListItem(result).content,
    visiblity: result.elevatedDefault,
    labelDescription: result.description,
    builtIn: result.builtIn,
    categoryDescription: categories[result.category],
  } as ILabelValueInfo)).sort(sortLabelValues);
  }